import React from 'react';
import { SmartDataTable } from '@src/components/SmartDataTable';
import {
  useInsideStockTransactionsColumns,
  useInsideStockTransactionsFormFields,
} from './hooks';

export const InsideStockTransactionsPage = () => {
  const columns = useInsideStockTransactionsColumns();
  const formFields = useInsideStockTransactionsFormFields();

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <SmartDataTable
        api={{
          resource: 'inside-inventory-transactions',
        }}
        title="Inside Stock Transactions"
        columns={columns}
        createForm={{
          fields: formFields as any,
          title: 'Add New Transaction',
          submitText: 'Create Transaction',
        }}
        editForm={{
          fields: formFields as any,
          title: 'Edit Transaction',
          submitText: 'Save Changes',
        }}
        formDisplayMode="modal"
        showCreate={false}
        showEdit={false}
        showDelete={false}
        showView={false}
        isFilter={false}
        pageSize={10}
        pageOptions={[10, 20, 50, 100]}
        showSizeChanger={true}
        showQuickJumper={false}
        // showExport={true}
        showColumnVisibility={true}
        tableProps={{
          scroll: {
            x: 'max-content',
            y: 'calc(100vh - 300px)',
          },
        }}
        rowKey="id"
      />
    </div>
  );
};
